import { Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { navigate } from "lib/routes/navigate"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function ChildFolder({ item }) {
    const { currentTab = "", regimeNavigatorRoute } = useBoundContext()
    return (
        <Button
            onClick={go}
            size="small"
            startIcon={<Iconify icon="mage:l-arrow-down-right" />}
            sx={{ px: 2, fontWeight: 100, justifyContent: "flex-start" }}
        >
            {item.label ?? ""}
        </Button>
    )

    function go() {
        navigate(getRoute())
    }

    function getRoute() {
        if (regimeNavigatorRoute) {
            return regimeNavigatorRoute(item)
        }

        return `/app/schedules?id=${item.id}&${currentTab}`
    }
}
